import { useState } from 'react';
import { useNavigate, Link, Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext.jsx';

export default function RegisterPage() {
  const { register, user, registrationOpen, loading } = useAuth();
  const navigate = useNavigate();
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [err, setErr] = useState(null);
  const [busy, setBusy] = useState(false);

  if (user && !loading) return <Navigate to="/" replace />;

  if (!registrationOpen && !loading) {
    return (
      <div className="auth-card">
        <h1>Registrazione chiusa</h1>
        <p className="muted">
          Le registrazioni sono chiuse. Se hai gi&agrave; un account,{' '}
          <Link to="/login">accedi</Link>.
        </p>
      </div>
    );
  }

  async function onSubmit(e) {
    e.preventDefault();
    setErr(null);
    setBusy(true);
    try {
      await register(email, password, name);
      navigate('/');
    } catch (ex) {
      setErr(ex.message || 'Errore registrazione');
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className="auth-card">
      <h1>Crea il tuo account</h1>
      {err && <div className="error">{err}</div>}
      <form onSubmit={onSubmit}>
        <div className="field">
          <label>Nome (opzionale)</label>
          <input value={name} onChange={(e) => setName(e.target.value)} />
        </div>
        <div className="field">
          <label>Email</label>
          <input
            type="email"
            autoComplete="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />
        </div>
        <div className="field">
          <label>Password (min 8 caratteri)</label>
          <input
            type="password"
            autoComplete="new-password"
            minLength={8}
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
          />
        </div>
        <button type="submit" disabled={busy}>
          {busy ? 'Registrazione…' : 'Registrati'}
        </button>
      </form>
      <p className="muted" style={{ marginTop: '1rem', textAlign: 'center' }}>
        Hai gi&agrave; un account? <Link to="/login">Accedi</Link>
      </p>
    </div>
  );
}
